<app-carousel-wrapper
  [selectorMode]="true"
  [selectedFlat]="selectedFlat"
  (positionSelected)="positionSelected.emit($event)"
  *ngIf="homeCarouselItems && homeCarouselItems.length"
  [carouselItems]="homeCarouselItems">

</app-carousel-wrapper>
